import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'invoices';

const generateBillingList = async () => {
  const method = 'POST';
  const url = `${USE_CASE_URL}`;

  const json = await request({ method, url });
  return json;
};

export default generateBillingList;
